import { render, staticRenderFns } from "./SyncErrors.vue?vue&type=template&id=f12daeae&scoped=true&"
import script from "./SyncErrors.vue?vue&type=script&lang=ts&"
export * from "./SyncErrors.vue?vue&type=script&lang=ts&"
import style0 from "./SyncErrors.vue?vue&type=style&index=0&id=f12daeae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12daeae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f12daeae')) {
      api.createRecord('f12daeae', component.options)
    } else {
      api.reload('f12daeae', component.options)
    }
    module.hot.accept("./SyncErrors.vue?vue&type=template&id=f12daeae&scoped=true&", function () {
      api.rerender('f12daeae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/SyncErrors.vue"
export default component.exports